import { AppConfigService } from '@/src/app/core/services/app-config.service';
import { Component, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { IAdvancedFilterData } from '@interfaces';
import { textComparatorOptions } from '../../data';
import { AdvancedFiltersFilterItemBase } from '../advanced-filters-filter-item-base/advanced-filters-filter-item-base.component';

@Component({
  selector: 'aup-advanced-filters-text',
  templateUrl: './advanced-filters-text.component.html',
  styleUrls: ['./advanced-filters-text.component.scss'],
  standalone: false,
})
export class AdvancedFiltersTextComponent extends AdvancedFiltersFilterItemBase {
  private readonly appConfigService = inject(AppConfigService);
  private readonly countryTextComparatorOptions =
    this.appConfigService.getCountryConfig().advancedFilters.textComparatorOptions;

  // Country config stores allowed comparator values; the shared data array provides UI labels.
  textComparatorOptions = textComparatorOptions.filter(comparator =>
    this.countryTextComparatorOptions.includes(comparator.value)
  );

  initForm() {
    this.formGroup = this.fb.group({
      type: [null, Validators.required],
      text: [null, Validators.required],
    });
  }

  getFilterValues(): Partial<IAdvancedFilterData> {
    if (!this.formGroup.valid) {
      return {};
    }

    const { type, text } = this.formGroup.value;

    return {
      value: null,
      complexValue: {
        type: type,
        value: text,
      },
    };
  }
}
